<form [formGroup]="findPersonForm">
  <div class="row gx-2 gy-3 flex-row">
    <label for="SelectFilterType" class="required-field col-lg-auto col-12">Filter by:</label>
    <div class="col-lg col-12">
      <select #filterTypeDD class="form-select" id="SelectFilterType" formControlName="FilterID" required aria-required="true">
        <option value="{{ null }}">Select a filter</option>
        <option *ngFor="let filter of peopleService.personFilterTypes$ | async" value="{{filter.FilterColumnName}}">{{ filter.FilterDisplayValue }}</option>
      </select>
      <div class="invalid-feedback">Please select a filter type.</div>
    </div>
    <div class="col-lg-auto col-12">
      <ng-container *ngIf="['Name', 'DateOfBirth', 'SSN', 'PhoneNumber'].indexOf(findPersonForm.get('FilterID').value) == -1">
        <label for="personFilterInput" class="visually-hidden">Filter text:</label>
        <input id="personFilterInput" formControlName="FilterInput" type="text" class="form-control" />
      </ng-container>
      <ng-container *ngIf="findPersonForm.get('FilterID').value === 'Name'">
        <div class="row">
          <label for="FirstName" class="col-auto mb-2">First name:</label>
          <div class="col-auto mb-2"><input id="FirstName" type="text" formControlName="FilterFirstNameInput" class="form-control" /></div>
        </div>
        <div class="row">
          <label for="LastName" class="col-auto">Last name:</label>
          <div class="col-auto mb-2"><input id="LastName" type="text" formControlName="FilterLastNameInput" class="form-control" /></div>
        </div>
      </ng-container>
      <ng-container *ngIf="findPersonForm.get('FilterID').value === 'DateOfBirth'">
        <label for="FilterDate" class="visually-hidden">Filter date</label>
        <p-calendar inputId="FilterDate" formControlName="FilterDate" [showIcon]="true" icon="far fa-calendar-alt" styleClass="d-flex" inputStyleClass="form-control" [showOnFocus]="false" [maxDate]="maxDateRule"></p-calendar>
      </ng-container>
      <ng-container *ngIf="findPersonForm.get('FilterID').value === 'SSN'">
        <label for="FilterSSN" class="visually-hidden">Filter SSN</label>
        <p-inputMask inputId="FilterSSN" formControlName="FilterSSN" mask="999-99-9999" styleClass="form-control"></p-inputMask>
      </ng-container>
      <ng-container *ngIf="findPersonForm.get('FilterID').value === 'PhoneNumber'">
        <label for="FilterPhoneNumber" class="visually-hidden">Filter Phone Number</label>
        <p-inputMask inputId="PhoneNumber" formControlName="FilterPhoneNumber" mask="(999) 999-9999" styleClass="form-control" [ariaRequired]="true" [maxlength]="80" [autoClear]="false"></p-inputMask>
      </ng-container>
      <div class="cross-validation-feedback" *ngIf="!findPersonForm.pristine && !!findPersonForm.get('FilterID').value && !findPersonForm.valid">
        Please enter a filter value.
      </div>
    </div>
    <div class="col-lg-auto col-12">
      <button type="button" class="btn btn-active mb-2" (click)="findMatchingPeople()" [disabled]="findPersonForm?.errors"><i class="fas fa-search" aria-hidden="true"></i> Find</button>
    </div>
  </div>
</form>
